export default __webpack_public_path__ + "static/media/curtain.622e7579.jpg";